import React from 'react';
import { CardMedia as MuiCardMedia } from '@mui/material';
import { styled } from '@mui/material/styles';

export const POST_CARD_HEIGHT = 200;
const POST_CARD_MEDIA_WIDTH = 300;
const POST_CARD_MEDIA_MOBILE_HEIGHT = 200;

const StyledCardMedia = styled(MuiCardMedia, {
  shouldForwardProp: (prop: any) => prop !== 'direction',
})(({ theme, direction = 'column' }: any) => ({
  width: direction === 'row' ? '100%' : POST_CARD_MEDIA_WIDTH,
  minHeight: POST_CARD_HEIGHT,
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    height: POST_CARD_MEDIA_MOBILE_HEIGHT,
    width: '100%',
  },
  '& .MuiSkeleton-root': {
    minHeight: POST_CARD_HEIGHT,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

function CardMedia({ children, ...props }: any) {
  return <StyledCardMedia {...props}>{children}</StyledCardMedia>;
}

export default CardMedia;
